module.exports = __webpack_public_path__ + "/img/CQFP-ymy9Vt.svg";